import { useContext } from 'react';

import { Issue } from '../../../constants';

import styles from './MultipleIssue.module.css';

import config from '../../../config';

import { TrackingContext } from '../../../tracking/Tracking.context';
import { HomeContext } from './Home.context';
import { Link } from '@tanstack/react-router';

export function MultipleIssue({ issues }: { issues: Array<Issue> }) {
	const latestIssue = issues[0];
	//const filterIssues = issues.filter((_, i) => i !== 0);
	return (
		<div className={styles['container']}>
			<div>
				<LatestIssue issue={latestIssue} />
			</div>
			<div>
				<Issues issues={issues} />
			</div>
		</div>
	);
}

const LatestIssue = ({ issue }: LatestIssueProps) => {
	const {
		userFeatures,
		selectedSection,
		onClickDisabledIssue,
		hasUserAccess,
	} = useContext(HomeContext);
	const { sendEvent } = useContext(TrackingContext);
	const hasAccess = hasUserAccess(userFeatures, issue);
	if (issue?.description) {
		issue.description = ``;
	}
	const { id, name, cover, description, slug } = issue;
	const contentProtection = config?.app?.contentProtection;
	const from = `${window.location.pathname}?section=${selectedSection}`;

	const imageComponent = hasAccess ? (
		<Link
			to={'/issues/$id'}
			params={{ id: slug ?? id }}
			from={from}
			onClick={() => {
				sendEvent({
					type: 'BTN_CLICK_ISSUE',
					data: {
						issue: {
							id: parseInt(`${issue.id}`, 10),
							slug: issue.slug,
						},
					},
				});
			}}
		>
			<figure role="button" style={{ cursor: 'pointer' }}>
				{contentProtection ? (
					<img
						src={cover}
						alt={`${name} - Cover`}
						width={340}
						className="content-protection"
						onContextMenu={e => e.preventDefault()}
					/>
				) : (
					<img src={cover} alt={`${name} - Cover`} width={340} />
				)}
			</figure>
		</Link>
	) : (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a
			href="#"
			className={styles['disabled']}
			onClick={() => {
				onClickDisabledIssue(issue);
			}}
		>
			<figure role="button" style={{ cursor: 'pointer' }}>
				{contentProtection ? (
					<img
						src={cover}
						alt={`${name} - Cover`}
						width={340}
						className="content-protection"
						onContextMenu={e => e.preventDefault()}
					/>
				) : (
					<img src={cover} alt={`${name} - Cover`} width={340} />
				)}
			</figure>
		</a>
	);

	return (
		<div className={styles['latest-issue']}>
			{imageComponent}

			<div className={styles['title']}>
				<h1>{name}</h1>
				{description ? <p>{description}</p> : null}
				<hr />
			</div>
		</div>
	);
};

interface LatestIssueProps {
	issue: Issue;
}

const Issues = ({ issues }: IssuesProps) => {
	return (
		<div className={styles['issues']}>
			{issues.map(issue => (
				<IssueComponent key={issue.id} issue={issue} />
			))}
		</div>
	);
};

interface IssuesProps {
	issues: Array<Issue>;
}

const IssueComponent = ({ issue }: IssueProps) => {
	const {
		userFeatures,
		onClickDisabledIssue,
		selectedSection,
		hasUserAccess,
	} = useContext(HomeContext);
	const { sendEvent } = useContext(TrackingContext);
	const hasAccess = hasUserAccess(userFeatures, issue);
	if (!issue.description) {
		issue.description = ``;
	}
	const { id, name, description, cover, slug } = issue;
	const contentProtection = config?.app?.contentProtection;
	const from = `${window.location.pathname}?section=${selectedSection}`;

	const imageComponent = hasAccess ? (
		<Link
			to={'/issues/$id'}
			params={{ id: slug ?? id }}
			from={from}
			onClick={() => {
				sendEvent({
					type: 'BTN_CLICK_ISSUE',
					data: {
						issue: {
							id: parseInt(`${issue.id}`, 10),
							slug: issue.slug,
						},
					},
				});
			}}
		>
			<figure role="button" style={{ cursor: 'pointer' }}>
				{contentProtection ? (
					<img
						src={cover}
						alt={`${name} - cover`}
						className="content-protection"
						onContextMenu={e => e.preventDefault()}
						width={340}
					/>
				) : (
					<img src={cover} alt={`${name} - cover`} width={340} />
				)}
			</figure>
		</Link>
	) : (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a
			href="#"
			className={styles['disabled']}
			onClick={() => {
				onClickDisabledIssue(issue);
			}}
		>
			<figure role="button" style={{ cursor: 'pointer' }}>
				{contentProtection ? (
					<img
						src={cover}
						alt={`${name} - Cover`}
						width={340}
						className="content-protection"
						onContextMenu={e => e.preventDefault()}
					/>
				) : (
					<img src={cover} alt={`${name} - Cover`} width={340} />
				)}
			</figure>
		</a>
	);
	const title = <h4>{name}</h4>;
	return (
		<div className={styles['issue']}>
			<div>{imageComponent}</div>
			<div>
				{title}
				<p>{description}</p>
			</div>
		</div>
	);
};

interface IssueProps {
	issue: Issue;
}
